import React, {Component} from 'react'
import { connect } from 'react-redux';
import { Field, change } from 'redux-form';
import renderField from '../fields/renderField';
import ReactFilestack from 'filestack-react';
import i18n from '../../translations/i18n';
import { newFileUpload, updateWordCount, fileDeletion, requestPrice } from '../../actions';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faTimes } from '@fortawesome/free-solid-svg-icons'
import URLSafeBase64 from 'urlsafe-base64';
import crypto from 'crypto';
import renderSelect from '../fields/renderSelect';
import { faSpinner } from '@fortawesome/free-solid-svg-icons';

const fsApiKey = process.env.REACT_APP_FILESTACK_API;

const PickerOptions = {
	accept: ['image/*', '.pdf', '.doc', '.docx', 'video/*', '.odt', '.xls', '.xlsx', '.ods', 'text/*'],
	allowManualRetry: true,
	maxFiles: 15,
	storeTo: {
		location: 's3',
	},
};

function getPadding(policy) {
	let padding = '';
	let count = 4 - policy.length % 4;
	if(count < 4) {
		for(let i=0; i<count; i++)
			padding += '=';
		}
	return padding;
}

function filestackPolicy(handler) {
	let expiry = Math.floor(new Date().getTime() / 1000 + 60*60*24*100);
	let policy = {expiry};
	policy.handle = handler;
	policy = JSON.stringify(policy);
	policy = URLSafeBase64.encode(new Buffer(policy));
	policy += getPadding(policy);
	let hmac = crypto.createHmac('SHA256', process.env.REACT_APP_FILESTACK_SECRET);
	hmac.setEncoding('hex').write(policy)
	hmac.end();

	return {policy, signature: hmac.read()};
}

const mapStateToProps = (state) => ({
	files: state.form.davron.values.fileSection === undefined ? [] : state.form.davron.values.fileSection,
	originalFiles: state.globals.files
})

const mapDispatchToProps = (dispatch) => ({
	fileUpload: (file, blob) => dispatch(newFileUpload(file, blob)),
	wordChange: (e) => dispatch(updateWordCount(e)),
	deleteFileFromStore: (e) => dispatch(fileDeletion(e)),
	priceRequest: (e) => dispatch(requestPrice(e)),
	setInitialValue: (form, name, value) => dispatch(change(form, name, value))
})

const OfficialFileSection = props => {
	let lng = props.lng;
	const required = value => value ? undefined : 'Required'
	const uploadedFiles = Object.keys(props.files).map((uploadfile, index) => {
		let error = (parseInt(props.files[uploadfile].pages, 10) === 0) ? true : false
		const clientOptions = {security: filestackPolicy(uploadfile)}
		const originalFile = props.originalFiles.filter(f => { return f.handle === uploadfile })
		const formattedIndex = index + 1 + "."
		function deletedFile(e) {
			props.deleteFile(e, uploadfile)
		}

		function onError(e) {
			console.log("Error", e)
		}
		return (
			<div className="row" key={`${uploadfile}.official`}>
				<div className="col-5 upload-name">
					<span className="small primary-color">{formattedIndex} </span>
					<span className="small">{originalFile[0].filename}</span>
					<span className="delete-cross">
						<ReactFilestack
							apikey={fsApiKey}
							source={uploadfile}
							customRender={({ onPick }) => (<button className="close" name="filestack" onClick={onPick}><FontAwesomeIcon icon={faTimes} color="#dc3545"/></button>)}
							onSuccess={deletedFile}
							onError={onError}
							action={'remove'}
							clientOptions={clientOptions}
						/>
					</span>
					{error&&<p className="small error">{i18n.t('upload.page_count_failed', {lng})}</p>}
				</div>
				<div className="col-3 col-md-4 official-document text-center">
					<Field
						name={`fileSection.${uploadfile}.document`}
						component={renderSelect}
						options={props.documents}
						onBlur={props.onDocumentBlur}
						placeholder={i18n.t('app.please_select', {lng})}
						validate={required}
					/>
					{!props.files[uploadfile].document&&<span className="small error">{i18n.t('official.select_document', {lng})}</span>}
				</div>
				<div className="col-4 col-md-3 form-input file-count">
					<Field
						name={`fileSection.${uploadfile}.pages`}
						validate={[props.isNumber, props.minValueZero]}
						dataField={uploadfile}
						component={renderField}
						placeholder="0"
						onBlur={props.onBlur}
						inputGroupText={props.label}
					/>
				</div>
			</div>
		)
	})
	
	return ( <div>{uploadedFiles}</div> )
}

let TranslationFileSection = props => {
	let lng = props.lng;
	const uploadedFiles = Object.keys(props.files).map((uploadfile, index) => {
		let error = (parseInt(props.files[uploadfile].words, 10) === 0) ? true : false
		const clientOptions = {security: filestackPolicy(uploadfile)}
		const originalFile = props.originalFiles.filter(f => { return f.handle === uploadfile })
		const formattedIndex = index + 1 + "."

		function deletedFile(e) {
			props.deleteFile(e, uploadfile)
		}
		return (
			<div className="row" key={`${uploadfile}.translation`}>
				<div className="col-md-9 col-sm-8 col-6 upload-name">
					<span className="small primary-color">{formattedIndex} </span>
					<span className="small">{originalFile[0].filename}</span>
					<span className="delete-cross">
						<ReactFilestack
							apikey={fsApiKey}
							source={uploadfile}
							customRender={({ onPick }) => (<button className="close" name="filestack" onClick={onPick}><FontAwesomeIcon icon={faTimes} color="#dc3545"/></button>)}
							onSuccess={deletedFile}
							action={'remove'}
							clientOptions={clientOptions}
						/>
					</span>
					{error&&<p className="small error">{i18n.t('upload.word_count_failed', {lng})}</p>}
				</div>
				<div className="col-md-3 col-sm-4 col-6 form-input file-count">
					<Field
						name={`fileSection.${uploadfile}.words`}
						validate={[props.isNumber, props.minValueZero]}
						dataField={uploadfile}
						component={renderField}
						placeholder="0"
						onBlur={props.onBlur}
						inputGroupText={props.label}
					/>
				</div>
			</div>
		)
	})
	
	return ( <div>{uploadedFiles}</div> )
}

let InterpretingFileSection = props => {
	const uploadedFiles = Object.keys(props.files).map(uploadfile => {
		const originalFile = props.originalFiles.filter(f => { return f.handle === uploadfile })
		const clientOptions = {security: filestackPolicy(uploadfile)}

		function deletedFile(e) {
			props.deleteFile(e, uploadfile)
		}
		return (
			<div className="row" key={uploadfile}>
				<div className="col-12 upload-name">
					<span className="primary-color">✓</span>
					<span className="small">{originalFile[0].filename}</span>
					<span className="delete-cross">
						<ReactFilestack
							apikey={fsApiKey}
							source={uploadfile}
							customRender={({ onPick }) => (<button className="close" name="filestack" onClick={onPick}><FontAwesomeIcon icon={faTimes} color="#dc3545"/></button>)}
							onSuccess={deletedFile}
							action={'remove'}
							clientOptions={clientOptions}
						/>
					</span>
				</div>
			</div>
		)
	})
	
	return ( <div>{uploadedFiles}</div> )
}

class UploadSection extends Component {
	constructor(props) {
		super(props)
		this.state = {
			uploading: false
		}
		this.filestackSuccess = this.filestackSuccess.bind(this);
		this.deleteFilestackFile = this.deleteFilestackFile.bind(this);
	}

	filestackSuccess(e) {
		e["filesUploaded"].forEach(file => {
			this.setState({uploading: true})

			let convertedDoc = 'https://process.filestackapi.com/output=format:txt/' + file.handle;

			fetch(convertedDoc).then(response => {
				if (response.status===200) {
					return response.blob();
				} else {
					this.props.setInitialValue('davron', 'desktopPublishing', true);
					return null;
				}
			})
			.then(filestackBlob => {
				return this.props.fileUpload(file, filestackBlob);
			})
			.then(() => {
				this.setState({uploading: false})
			})
			.catch(error => {
				console.warn(error);
				this.setState({uploading: false})
			})
		});
	}

	deleteFilestackFile(e, handle) {
		this.props.deleteFileFromStore(handle)
	}

	render() {
		let lng = this.props.lng;
		let label = (this.props.service==="official" ? i18n.t('upload.pages', {lng}) : i18n.t('upload.words', {lng}))

		const minValue = min => value => value && value < min ? `${i18n.t('upload.min_value', {lng})} ${min}` : undefined
		const minValueZero = minValue(0)
		const isNumber = value => value && isNaN(Number(value)) ? i18n.t('upload.is_number', {lng}) : undefined
		const buttonText = i18n.t('upload.button_text', {lng})

		return (
			<div>
				<div className="subtitle title title-border title-border text-left">
					<h6>{i18n.t('upload.title', {lng})}</h6>
				</div>
				{this.props.service==="translation"&&<p className="small tooltip-text">{i18n.t('upload.translation_subtitle', {lng})}</p>}
				{this.props.service==="official"&&<p className="small tooltip-text">{i18n.t('upload.official_subtitle', {lng})}</p>}
				<div className="row mt-3">
					<div className="col-md-9 col-sm-8 col-6 input-group upload-btn">
					{!this.state.uploading&&<ReactFilestack 
						apikey={fsApiKey}
						componentDisplayMode={{
							type: 'button',
							customText: buttonText,
							customClass: 'filestackButton'
						}}
						actionOptions={PickerOptions}
						onSuccess={this.filestackSuccess}
						onError={(e) => console.warn(e)}

					/>}
					{this.state.uploading&&<div className="btn-spinner">
						<FontAwesomeIcon icon={faSpinner} color="#0D3680" size="xs" spin/>
					</div>}
					</div>
					{this.props.service!=="interpreting"&&Object.keys(this.props.files).length>0&&
					<div className="col-md-3 col-sm-4 col-6 pt-1 total-files">
						<span>{i18n.t('upload.total', {lng})}</span>
						<Field
							name="totalQty"
							component={renderField}
							placeholder="Total"
							readOnly={true}
							disabled={true}
							inputGroupText={label}
						/>
						<p className="extra-small">{i18n.t('upload.totalcount_tooltip', {lng})}</p>
					</div>}
				</div>
				{this.props.service==="translation"&&<TranslationFileSection
					files={this.props.files}
					originalFiles={this.props.originalFiles}
					label={label}
					onBlur={this.props.wordChange}
					lng={this.props.lng}
					deleteFile={this.deleteFilestackFile}
					minValueZero={minValueZero}
					isNumber={isNumber}
				/>}
				{this.props.service==="official"&&<OfficialFileSection
					files={this.props.files}
					originalFiles={this.props.originalFiles}
					label={label}
					onBlur={this.props.wordChange}
					onDocumentBlur={(this.props.priceRequest)}
					lng={this.props.lng}
					deleteFile={this.deleteFilestackFile}
					documents={this.props.documents}
					minValueZero={minValueZero}
					isNumber={isNumber}
				/>}
				{this.props.service==="interpreting"&&<InterpretingFileSection 
					files={this.props.files}
					originalFiles={this.props.originalFiles}
					label={label}
					onBlur={this.props.wordChange}
					lng={this.props.lng}
					deleteFile={this.deleteFilestackFile}
				/>}
			</div>
		)
	}
}

export default UploadSection = connect( mapStateToProps, mapDispatchToProps )(UploadSection)



// WEBPACK FOOTER //
// ./src/components/common/upload.js